import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const deskDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "desk-detect-example",
  version: 1,
  title: "Everyday objects",
  description: "Find specific items",
  subdescription: "Pick out individual products from a cluttered flat lay.",
  thumbnailUuid: BASE_ASSETS.deskFlatLayExample.uuid,
  assets: [BASE_ASSETS.deskFlatLayExample],
  detect: {
    mediaUuid: BASE_ASSETS.deskFlatLayExample.uuid,
    categories: ["glasses", "candle", "lip balm", "keyboard", "pen"],
    config: {
      output: "box",
    },
  },
};
